import PropTypes from 'prop-types';
import { Flyout } from '@celltrak/ui-components';

import AgenciesTabs from '../AgenciesTabs';

import styles from './AgenciesFlyout.module.scss';
import useAgenciesFlyout from './AgenciesFlyout.hooks';

const AgenciesFlyout = ({ show }) => {
  const { handleOnCloseFlyout, flyoutTitle, keepOpen } = useAgenciesFlyout();

  return (
    <Flyout
      show={show}
      className={styles.agenciesFlyout}
      heading="Agencies"
      onCloseClick={() => handleOnCloseFlyout()}
      title={flyoutTitle}
      keepOpen={keepOpen}
    >
      <AgenciesTabs />
    </Flyout>
  );
};

AgenciesFlyout.propTypes = {
  show: PropTypes.bool,
};

AgenciesFlyout.defaultProps = {
  show: '',
};

export default AgenciesFlyout;
